import React from 'react';
import Button from 'reactstrap/lib/Button';
import Form from 'reactstrap/lib/Form';
import Row from "@gqlapp/base/Row";
import Col from "@gqlapp/base/Col";
import Back from "@xem/icon/button/back.svg";

export default function RegisterFormButton({ handleSubmit, submitting, nextLabel, setRegisterValues, values, values: { level } }) {
  return (<>
    <Form name="register" onSubmit={handleSubmit}>
      <Row none>
        <Col>
          <Button
            color={'default text-primary p-0 border-0'}
            type={"submit"}
            style={{ minHeight: `40px`}}
            onClick={()=>setRegisterValues(values, level - 1 )}
          >
            <Back width={'16px'} height={'16px'} />&nbsp;&nbsp;{'Quay lại'.t()}
          </Button>
        </Col>
        <Col xs={'auto'} className={'d-flex justify-content-center'}>
          <Button
            color={'primary'}
            style={{ minHeight: `40px`, minWidth: '120px'}}
            className={'text-uppercase text-white border-0 rounded-1'}
            type={"submit"}
            disabled={submitting}
          >
            {nextLabel.t()}
          </Button>
        </Col>
      </Row>
    </Form>
  </>)
}
